import { Link } from "react-router-dom";

import classes from "./ModesSwitch.module.css";

export const ModesSwitch = () => {
  return (
    <Link to="/">
        <div className={classes.switch}>
            <span className={`slimRegularLargeText ${classes.hoverState}`}>Entdecker</span>
            <div className={classes.creatorViewContainer}>
              < span className="slimRegularLargeText">Anbieter</span>
            </div>
        </div>
    </Link>
  );
};

export default ModesSwitch;